const documentUrl = "https://docs.google.com/document/d/e/2PACX-1vSLd_yEkp0D0p35FSLHjo4nnR5gTpWClbuUTfKGYKlB6VCmB_51zEAcZy32NucSahAD8-vCD7YifRTb/pub";
const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export default function NScannerPrivacyPage() {
  return (
    <main className="legal-page">
      <nav className="legal-nav"><a className="brand" href={`${basePath}/`}><span>N</span><b>Naon<small>3D Platform</small></b></a></nav>
      <article className="legal-content legal-document-page">
        <p className="eyebrow">PRIVACY POLICY</p>
        <h1>NScanner 개인정보처리방침</h1>
        <p className="legal-meta">Google 문서의 최신 게시 내용을 표시합니다.</p>
        <p><a href={documentUrl} target="_blank" rel="noreferrer">Google 문서에서 열기</a> · <a href={`${basePath}/privacy`}>NModeler 개인정보처리방침</a></p>
        <iframe className="legal-document" src={`${documentUrl}?embedded=true`} title="NScanner 개인정보처리방침" />
      </article>
    </main>
  );
}
